import NotificationList from "./notificationList";

export default NotificationList;
